const items = ["Civil Work", "Interior Work", "Modular Kitchen", "Restoration & Renovation"];

export default function Marquee() {
  return (
    <section data-testid="editorial-marquee" aria-hidden="true" className="py-10 lg:py-14 bg-white border-b border-zinc-200 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span
                  className={`font-heading text-4xl sm:text-5xl lg:text-7xl font-light uppercase tracking-tight px-6 lg:px-10 ${
                    i % 2 === 1 ? "text-outline" : "text-zinc-950"
                  }`}
                >
                  {item}
                </span>
                <span className="w-2.5 h-2.5 bg-zinc-300 rotate-45 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
